import { City, Country, State } from 'country-state-city';
import fallbackCountriesData from './countries-states-cities.json';

const toSortedUniqueStrings = (values) =>
  Array.from(
    new Set(
      (values || [])
        .map((value) => (typeof value === 'string' ? value.trim() : ''))
        .filter(Boolean)
    )
  ).sort((a, b) => a.localeCompare(b));

const buildLocationData = () => {
  try {
    const countries = Country.getAllCountries() || [];
    const allStates = State.getAllStates() || [];
    const allCities = City.getAllCities() || [];

    const statesByCountry = new Map();
    for (const state of allStates) {
      const countryCode = state?.countryCode;
      const stateCode = state?.isoCode;
      const stateName = state?.name;
      if (!countryCode || !stateName) continue;

      const existing = statesByCountry.get(countryCode) || [];
      existing.push({
        code: stateCode || stateName.slice(0, 3).toUpperCase(),
        name: stateName,
      });
      statesByCountry.set(countryCode, existing);
    }

    const citiesByState = new Map();
    const citiesByCountry = new Map();
    for (const city of allCities) {
      const cityName = city?.name;
      const countryCode = city?.countryCode;
      const stateCode = city?.stateCode;
      if (!cityName || !countryCode) continue;

      const stateKey = `${countryCode}:${stateCode || ''}`;
      const stateCities = citiesByState.get(stateKey) || [];
      stateCities.push(cityName);
      citiesByState.set(stateKey, stateCities);

      const countryCities = citiesByCountry.get(countryCode) || [];
      countryCities.push(cityName);
      citiesByCountry.set(countryCode, countryCities);
    }

    const normalizedCountries = countries
      .map((country) => {
        const countryCode = country?.isoCode;
        const countryName = country?.name;
        if (!countryCode || !countryName) return null;

        const countryStates = (statesByCountry.get(countryCode) || [])
          .map((state) => {
            const stateCities = toSortedUniqueStrings(
              citiesByState.get(`${countryCode}:${state.code}`) || []
            );
            return {
              code: state.code,
              name: state.name,
              cities: stateCities,
            };
          })
          .sort((a, b) => a.name.localeCompare(b.name));

        if (!countryStates.length) {
          const fallbackCities = toSortedUniqueStrings(
            citiesByCountry.get(countryCode) || []
          );
          if (fallbackCities.length) {
            countryStates.push({
              code: countryCode,
              name: countryName,
              cities: fallbackCities,
            });
          }
        }

        return {
          code: countryCode,
          name: countryName,
          states: countryStates,
        };
      })
      .filter(Boolean)
      .sort((a, b) => a.name.localeCompare(b.name));

    if (!normalizedCountries.length) {
      return fallbackCountriesData;
    }

    return { countries: normalizedCountries };
  } catch (error) {
    return fallbackCountriesData;
  }
};

const countriesData = buildLocationData();

export default countriesData;
